import { fetchQuery } from "../shared/http-client";

export async function deleteUserAPI(id: number): Promise<void> {
  await fetchQuery(`users/${id}`, {
    method: "DELETE",
  });
}
